import { render, staticRenderFns } from "./SixthSection.vue?vue&type=template&id=32a2a39b&"
import script from "./SixthSection.vue?vue&type=script&lang=ts&"
export * from "./SixthSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports